import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CloseIcon from "@mui/icons-material/Close";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import {
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { VENDOR_PORTAL_URL } from "../../../../API";
import { AddQuestionsilllus } from "../../../../Icons/AddQuestionsilllus";
import { DashboardPlusicon } from "../../../../Icons/DashboardPlusicon";
import { EditingIcon } from "../../../../Icons/Editing-Icon";
import { updateLoader } from "../../../../_redux/LoaderSlice";
import { updateSnackbar } from "../../../../_redux/SnackbarSlice";
import {
  deleteApi,
  postApi,
  putApi,
  sessionExpired,
} from "../../../../_redux/_apiHelpers/_apihelper";
import {
  getQuestionsListAsync,
  getQuestionsListStartReducer,
} from "../../../../_redux/_services/JobPostingSlice";
import {
  Labels,
  longTextLenght,
  shortTextLenght,
} from "../../../../_utilities/constants";
import { GetUserId, getAttributes } from "../../../../_utilities/getUserInfo";
import RightSideBar from "../../../../components/Rightsidebar/RightSideBar";
import ScreeningQuestionCard from "../../../../components/ScreeningQuestionCard/ScreeningQuestionCard";
import ScreeningQuestionChips from "../../../../components/ScreeningQuestionChips/ScreeningQuestionChips";
import { SCREENING_QUESTION_TEMPLATES } from "../../../../constants/screeningQuestionTemplates";
import "./ScreeningQuestions.css";
import {
  ValidatesOption,
  ValidatesQuestions,
  ValidatesType,
} from "./Validator";

import axios from "axios";

const DeleteIcon = `${process.env.PUBLIC_URL}/assests/img/delete_icon_red_color.svg`;
const initalState = { data: null, message: "", isloader: true };
const pannelobj = {
  title: "Add New Question",
  description: "",
  // bgImage: "",
  pageName: "vendorportal",
};

const ScreeningQuestions = ({
  isQuestionData = false,
  jobDetailsID,
  onReceiveData = () => {},
  getCreatedJob,
}) => {
  const JobId = jobDetailsID;
  const [isRightSidePannel, setIsRightSidePannel] = useState(false);
  const [jobCode, setJobCode] = useState(null);
  const [isValidUser, setIsValidUser] = useState(false);
  const [cloneQuestions, setCloneQuestions] = useState([]);
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const [questions, setQuestions] = React.useState([]);
  const [showNoData, setShowNoData] = useState(false);
  const dispatch = useDispatch();

  const showLoader = useSelector((state) => state.Loader.value);
  const defaultQuestion = {
    question: "",
    subQuestion: [""],
    multiOptions: [""],
    text: "",
    numeric: "",
    type: "",
    status: "1",
    jobPostingsId: JobId,
    id: null,
    isEdit: false,
    templateId: null,
    placeholderValues: {},
    isTemplateQuestion: false,
  };

  const handleAddTemplateQuestion = (questionObj) => {
    const hasUnsavedCustom = questions.some(
      (q) => q.isEdit === true && !q.isTemplateQuestion,
    );
    if (hasUnsavedCustom) {
      dispatch(
        updateSnackbar({
          type: "error",
          message: "Please save the current question before adding another",
        }),
      );
      return;
    }
    setQuestions([...questions, questionObj]);
  };

  const handleTemplateQuestionChange = (questionIndex, updatedQuestion) => {
    const updated = [...questions];
    updated[questionIndex] = updatedQuestion;
    setQuestions(updated);
  };

  const handleRemoveTemplateQuestion = async (questionIndex) => {
    const q = questions[questionIndex];
    if (q.id) {
      try {
        const userInfo = await getAttributes();
        const userId = userInfo?.[0]?.userId || "";
        dispatch(updateLoader(true));
        await deleteApi(
          `${VENDOR_PORTAL_URL}/${JobId}/questions/${q.id}`,
          {},
          process.env.REACT_APP_JOBOPENING,
          { UserId: userId },
        );
        dispatch(updateLoader(false));
      } catch (error) {
        dispatch(updateLoader(false));
        if (
          error?.response?.status === 405 ||
          error?.response?.status === 406 ||
          error?.response?.status === 401
        ) {
          return sessionExpired(error?.response?.data?.message);
        }
        dispatch(
          updateSnackbar({
            type: "error",
            message: "Failed to remove question. Please try again.",
          }),
        );
        return;
      }
    }
    const newQuestions = [...questions];
    newQuestions.splice(questionIndex, 1);
    setQuestions(newQuestions);
  };

  const handleSaveTemplateQuestion = async (questionIndex) => {
    const q = questions[questionIndex];
    const template = SCREENING_QUESTION_TEMPLATES.find(
      (t) => t.id === q.templateId,
    );
    if (!template) return;

    let finalQuestion = template.questionTemplate;
    if (template.placeholders.length > 0) {
      const allFilled = template.placeholders.every(
        (p) => q.placeholderValues?.[p.key]?.trim(),
      );
      if (!allFilled) {
        dispatch(
          updateSnackbar({
            type: "error",
            message: "Please fill in all required fields",
          }),
        );
        return;
      }
      template.placeholders.forEach((p) => {
        finalQuestion = finalQuestion.replace(
          `[${p.key}]`,
          q.placeholderValues[p.key].trim(),
        );
      });
    }

    const buildSubObj = (list) => {
      const obj = {};
      list.forEach((val, i) => (obj[i + 1] = val));
      return obj;
    };

    const allowedTypes = ["Multiple Choice", "Multi Select", "Single Select"];
    const qType = (q.type || "").trim();
    const subObj =
      allowedTypes.includes(qType) && q.subQuestion
        ? buildSubObj(q.subQuestion.filter((s) => s.trim() !== ""))
        : null;

    const isUpdate = q.id !== null && typeof q.id === "number";
    const questionObj = {
      question: finalQuestion,
      type: q.type,
      subQuestion: subObj,
      status: q.status,
    };

    const questionPayload = isUpdate
      ? { ...questionObj, jobPostingsId: JobId }
      : { jobPostingsId: JobId, questions: [questionObj] };

    const endpoint = isUpdate
      ? `${VENDOR_PORTAL_URL}/${JobId}/questions/${q.id}`
      : `${VENDOR_PORTAL_URL}/${JobId}/questions`;

    const userInfo = await getAttributes();
    const currentUserId = userInfo?.[0]?.userId || "";
    const jobObj = { jobId: JobId, jobCode: jobCode, userId: currentUserId };

    dispatch(updateLoader(true));
    try {
      const response = isUpdate
        ? await putApi(endpoint, questionPayload, process.env.REACT_APP_JOBOPENING)
        : await postApi(
            endpoint,
            questionPayload,
            process.env.REACT_APP_JOBOPENING,
            false,
            jobObj,
          );

      if (response.status !== 200) {
        throw new Error(response?.message || "Failed to save question");
      }

      dispatch(
        updateSnackbar({
          type: "success",
          message: isUpdate
            ? "Screening question updated successfully"
            : "Screening question added successfully",
        }),
      );

      const filtered = questions.filter((_, i) => i !== questionIndex);
      setQuestions(filtered);

      await fetchQuestions();
    } catch (err) {
      if (
        err?.response?.status === 405 ||
        err?.response?.status === 406 ||
        err?.response?.status === 401
      ) {
        return sessionExpired(err?.response?.data?.message);
      }
      dispatch(
        updateSnackbar({
          type: "error",
          message: "Something went wrong. Please try again.",
        }),
      );
    } finally {
      dispatch(updateLoader(false));
    }
  };

  const handleCancelTemplateQuestion = (questionIndex) => {
    const q = questions[questionIndex];
    if (q.id === null) {
      const updated = questions.filter((_, i) => i !== questionIndex);
      setQuestions(updated);
    } else {
      fetchQuestions();
    }
  };

  const handleEditTemplateQuestion = (questionIndex) => {
    const updated = [...questions];
    updated[questionIndex] = { ...updated[questionIndex], isEdit: true };
    setQuestions(updated);
  };

  const addQuestion = () => {
    console.log(questions);
    let filterData = questions.filter((x) => x.isEdit === true);
    if (filterData.length === 0 || questions.length === 0) {
      setQuestions([defaultQuestion, ...questions]);
      setIsRightSidePannel(true);
    } else {
      dispatch(
        updateSnackbar({
          type: "error",
          message: "Please save the changes",
        }),
      );
    }
  };

  useEffect(() => {
    let timer;
    if (questions.length === 0 && !showLoader) {
      timer = setTimeout(() => {
        setShowNoData(true);
      }, 800);
    } else {
      setShowNoData(false);
    }
    return () => clearTimeout(timer);
  }, [questions, showLoader]);

  useEffect(() => {
    if (JobId) {
      let subPathObj = JSON.parse(localStorage.getItem("subpathObj"));
      if (subPathObj && subPathObj.length > 0) {
        let index = subPathObj.findIndex((x) => x.id === JobId);
        let jobCode = "";
        if (index !== -1) {
          jobCode = subPathObj[index].name;
        } else {
          if (getCreatedJob) {
            let isJobCode = getCreatedJob.jobCode;
            setJobCode(isJobCode);
          }
        }
        if (jobCode) {
          let matches = jobCode.match(/\(([^)]+)\)/g);
          let splitJobcode = matches[matches.length - 1].replace(/[()]/g, "");
          setJobCode(splitJobcode);
        }
      } else {
        if (getCreatedJob) {
          let isJobCode = getCreatedJob.jobCode;
          setJobCode(isJobCode);
        }
      }
    }
  }, [JobId, getCreatedJob]);

  const fetchQuestions = async (id) => {
    let getUserDetails = await getAttributes();
    if (!JobId) return null;
    const customHeaders = {
      jobCode: jobCode,
      userId: getUserDetails[0].userId,
    };
    dispatch(getQuestionsListAsync(JobId, customHeaders));
  };

  const { data: questionsData, code: questionStatus } = useSelector(
    (state) => state.GetQuestionsList,
  );
  const { data: questionCloneData, code: questionCloneStatus } = useSelector(
    (state) => state.GetListofQuestions,
  );

  useEffect(() => {
    if (questionStatus === 200 && questionsData?.length > 0) {
      let updatedQuestions = getQuestionsData(questionsData);

      // Carry forward unsaved template questions (not yet persisted) whose
      // question text isn't already in the just-fetched list.
      const savedTexts = new Set(updatedQuestions.map((q) => q.question));
      const unsavedTemplateQuestions = questions.filter(
        (q) =>
          q.isTemplateQuestion && q.id === null && !savedTexts.has(q.question),
      );
      if (unsavedTemplateQuestions.length > 0) {
        updatedQuestions = [...updatedQuestions, ...unsavedTemplateQuestions];
      }

      setQuestions(updatedQuestions);
      dispatch(getQuestionsListStartReducer(initalState));
    } else if (questionStatus === 404) {
      setIsValidUser(true);
    }
  }, [questionsData, questionStatus, initalState]); // added initalState

  useEffect(() => {
    if (questionCloneStatus === 200 && questionCloneData?.length > 0) {
      let updatedQuestions = getQuestionsData(questionCloneData);
      setSelectedQuestions(updatedQuestions);
      setCloneQuestions(updatedQuestions);
      onReceiveData(updatedQuestions, false, "CloneQuestions");
    }
  }, [questionCloneData, questionCloneStatus]);

  useEffect(() => {
    if (cloneQuestions?.length > 0 && questions?.length > 0) {
      const updatedArray = cloneQuestions.filter(
        (list) => !questions.some((item) => isSameRecord(list, item)),
      );
      setCloneQuestions(updatedArray);
      onReceiveData(updatedArray, false, "CloneQuestions");
    } else if (questions?.length > 0) {
      let isQuestionEdit = questions.filter((x) => x.isEdit === true);
      onReceiveData(isQuestionEdit, false, "CloneQuestions");
    }
  }, [questions, cloneQuestions]);

  function getQuestionsData(data) {
    return data
      .map((item) => {
        let isSubQuestionAvailable =
          item.subQuestion && item.subQuestion !== "null";
        return {
          ...item,
          isEdit: false,
          subQuestion: isSubQuestionAvailable
            ? Object.values(JSON.parse(item.subQuestion))
            : [],
        };
      })
      .sort((a, b) => a.id - b.id);
  }

  function isSameRecord(a, b) {
    const ignoreFields = ["id", "jobPostingsId"];
    const filteredA = Object.fromEntries(
      Object.entries(a).filter(([k]) => !ignoreFields.includes(k)),
    );
    const filteredB = Object.fromEntries(
      Object.entries(b).filter(([k]) => !ignoreFields.includes(k)),
    );
    return JSON.stringify(filteredA) === JSON.stringify(filteredB);
  }

  useEffect(() => {
    fetchQuestions();
  }, [JobId]);

  const onReceivePropsHandler = (pannel, load) => {
    setIsRightSidePannel(pannel);
    let newQuestions = [...questions];
    newQuestions.splice(0, 1);
    setQuestions(newQuestions);
    if (load?.type) {
      dispatch(updateSnackbar({ type: load?.type, message: load?.message }));
    }
    setTimeout(() => {
      fetchQuestions();
    }, 600);
  };

  useEffect(() => {
    if (isQuestionData === true) {
      if (cloneQuestions?.length === 0) {
        onReceiveData(questions, false, "questions");
      } else if (cloneQuestions?.length > 0) {
        onReceiveData(questions, true, "questions");
      }
    }
  }, [isQuestionData, cloneQuestions]);

  const onSelectedRecordHandler = (object) => {
    let selectedCloneQuestions = [...selectedQuestions];
    const index = selectedCloneQuestions.findIndex(
      (item) => item.id === object.id,
    );
    if (index !== -1) {
      selectedCloneQuestions.splice(index, 1);
    } else {
      selectedCloneQuestions.push(object);
    }
    setSelectedQuestions(selectedCloneQuestions);
  };

  const handleDiscard = () => {
    setCloneQuestions([]);
    setSelectedQuestions([]);
    onReceiveData([], false, "CloneQuestions");
  };

  const onSaveAllHandler = async () => {
    try {
      if (selectedQuestions.length > 0) {
        let finalObj = {
          jobPostingsId: selectedQuestions[0].jobPostingsId,
          questions: selectedQuestions,
        };
        dispatch(updateLoader(true));
        const postData = await postApi(
          `${VENDOR_PORTAL_URL}/${JobId}/questions`,
          finalObj,
          process.env.REACT_APP_JOBOPENING,
        );
        dispatch(
          updateSnackbar({
            type: postData ? "success" : "error",
            message: postData
              ? "Screening question added successfully"
              : "Data is not saved",
          }),
        );
        dispatch(updateLoader(false));
        setTimeout(() => {
          handleDiscard();
          fetchQuestions();
        }, 1000);
      } else {
        dispatch(
          updateSnackbar({
            type: "error",
            message: "No screening questions selected",
          }),
        );
      }
    } catch (error) {
      if (
        error?.response?.status === 405 ||
        error?.response?.status === 406 ||
        error?.response?.status === 401
      ) {
        return sessionExpired(error?.response?.data?.message);
      }
    }
  };

  return (
    <div className="postingQuestion1">
      <div style={{ position: "relative", textAlign: "right" }}>
        {!isValidUser && cloneQuestions.length === 0 && (
          <div className="addquestionicontext" onClick={addQuestion}>
            <DashboardPlusicon width={35} height={36} />
            <p className="addquestion"> New Question</p>
          </div>
        )}
      </div>
      {questions.length > 0 && (
        <div>
          {questions.map((item, index) =>
            item.isTemplateQuestion ? (
              <ScreeningQuestionCard
                key={`tpl-${item.templateId}-${index}`}
                question={item}
                onRemove={() => handleRemoveTemplateQuestion(index)}
                onChange={(updated) =>
                  handleTemplateQuestionChange(index, updated)
                }
                onSave={() => handleSaveTemplateQuestion(index)}
                onCancel={() => handleCancelTemplateQuestion(index)}
                onEdit={() => handleEditTemplateQuestion(index)}
                isSaved={item.id !== null && !item.isEdit}
              />
            ) : (
              <QuestionForm
                key={`qf-${item.id || index}`}
                index={index}
                jobDetailsID={jobDetailsID}
                item={item}
                fetchQuestions={fetchQuestions}
                questions={questions}
                setQuestions={setQuestions}
                getCreatedJob={getCreatedJob}
              />
            ),
          )}
        </div>
      )}
      {!isValidUser && cloneQuestions.length === 0 && (
        <ScreeningQuestionChips
          recommendations={[]}
          existingQuestions={questions}
          onAddQuestion={handleAddTemplateQuestion}
          onAddCustomQuestion={addQuestion}
          jobPostingsId={JobId}
        />
      )}
      {questions?.length === 0 && !showLoader && (
        <div className="nodatasection">
          <img
            src={
              process.env.PUBLIC_URL + "/assests/vendorportal/AddQuestions.svg"
            }
            alt="noResult"
          />
          No screening questions available
        </div>
      )}
      {cloneQuestions && cloneQuestions.length > 0 && (
        <>
          {/* Bottom Actions */}
          <div
            style={{
              display: "flex",
              gap: "15px",
              justifyContent: "flex-end",
              marginTop: "-58px",
            }}
          >
            <Button
              size="small"
              sx={{ color: "red", textTransform: "none" }}
              onClick={handleDiscard}
            >
              Discard
            </Button>
            <Button
              className="buttonHover"
              size="small"
              variant="contained"
              style={{
                backgroundColor: "var(--primary-bg-color)",
                color: "var(--primary-background-text-color)",
                borderRadius: "10px",
                width: "6rem",
                fontSize: "14px",
                fontWeight: "",
                marginleft: "20px",
              }}
              onClick={onSaveAllHandler}
            >
              Save
            </Button>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "8px 0",
              marginTop: "50px",
            }}
          >
            {/* Left column header */}
            <div style={{ flex: 2, textAlign: "left" }}>
              <h2 style={{ margin: 0 }}>Questions List</h2>
            </div>

            {/* Right column header */}
            <div style={{ flex: 1, textAlign: "left" }}>
              <h2 style={{ margin: 0 }}>Question Type</h2>
            </div>
          </div>
          <Divider />
          {/* Questions */}
          {cloneQuestions.map((q, index) => (
            <div key={index}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "8px 0",
                }}
              >
                {/* Left side: Checkbox + Question text */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flex: 2,
                  }}
                >
                  <Checkbox
                    checked={
                      selectedQuestions.map((x) => x.id).includes(q.id) || false
                    }
                    onChange={(e) => onSelectedRecordHandler(q)}
                    icon={<CheckBoxOutlineBlankIcon />}
                    checkedIcon={<CheckBoxIcon sx={{ color: "var(--primary-bg-color)" }} />}
                  />
                  <span style={{ color: "#000000", fontSize: "20px" }}>
                    {q.question}
                  </span>
                </div>
                <div style={{ flex: 1, textAlign: "left" }}>
                  <span style={{ color: "#000000", fontSize: "20px" }}>
                    {q.type}
                  </span>
                </div>
              </div>
              <Divider />
            </div>
          ))}
        </>
      )}
      {isRightSidePannel ? (
        <div className="questionsRightsidepanel">
          <RightSideBar
            componentData={
              <ComponentRenderData
                onReceivechildProps={onReceivePropsHandler}
                questionsData={questions}
                jobDetailsID={jobDetailsID}
                setQuestions={setQuestions}
                getCreatedJob={getCreatedJob}
              />
            }
            componentLayout={pannelobj}
            footerImg={<AddQuestionsilllus />}
            onReceiveProps={onReceivePropsHandler}
          />
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

const QuestionForm = ({
  index,
  jobDetailsID,
  item,
  fetchQuestions,
  questions,
  setQuestions,
  getCreatedJob,
  isClone = false,
  compare = null,
}) => {
  const JobId = jobDetailsID;
  const dispatch = useDispatch();
  const ValidateQuestions = ValidatesQuestions();
  const ValidateType = ValidatesType();
  const ValidateOption = ValidatesOption();
  const [, forceUpdate] = useState(false);
  const [isEdit, setIsEdit] = React.useState(null);
  const [jobCode, setJobCode] = useState(null);
  const [maxLength, setMaxLength] = useState(shortTextLenght);

  const [openPopup, setOpenPopup] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);

  useEffect(() => {
    if (JobId) {
      let subPathObj = JSON.parse(localStorage.getItem("subpathObj"));
      if (subPathObj && subPathObj.length > 0) {
        let index = subPathObj.findIndex((x) => x.id === JobId);
        let jobCode = "";
        if (index !== -1) {
          jobCode = subPathObj[index].name;
        } else {
          if (getCreatedJob) {
            let isJobCode = getCreatedJob.jobCode;
            setJobCode(isJobCode);
          }
        }

        if (jobCode) {
          let matches = jobCode.match(/\(([^)]+)\)/g);
          let splitJobcode = matches[matches.length - 1].replace(/[()]/g, "");
          // let jobCodeobj = {jobId: JobId, jobCode: splitJobcode[0]}
          setJobCode(splitJobcode);
        }
      } else {
        if (getCreatedJob) {
          let isJobCode = getCreatedJob.jobCode;
          setJobCode(isJobCode);
        }
      }
    }
  }, [JobId, getCreatedJob]);

  const addOption = (index, itemType) => {
    if (
      ValidateQuestions.current.allValid() &&
      ValidateType.current.allValid()
    ) {
      const newQuestions = [...questions];
      newQuestions[index].subQuestion.push("");
      setQuestions(newQuestions);
      // ✅ Reset option validation state
      if (ValidateOption.current) {
        ValidateOption.current.hideMessages();
        ValidateOption.current.fields = {}; // clear tracked invalid fields
      }
      forceUpdate(); // re-render without showing errors
    }
  };
  const removeQuestion = async (index) => {
    const newQuestions = [...questions];
    let id = newQuestions[index].id;
    newQuestions.splice(index, 1);
    if (isClone === true) {
      setQuestions(newQuestions);
    } else {
      try {
        const userInfo = await getAttributes();
        const userId = userInfo?.[0]?.userId || "";
        dispatch(updateLoader(true));
        const postData = await deleteApi(
          `${VENDOR_PORTAL_URL}/${JobId}/questions/${id}`,
          {},
          process.env.REACT_APP_JOBOPENING,
          { UserId: userId },
        );
        let data = postData.data;
        if (data.code === 200) {
          setQuestions(newQuestions);
          dispatch(
            updateSnackbar({
              type: postData ? "success" : "error",
              message: postData
                ? "Question deleted successfully"
                : "Data is not deleted",
            }),
          );
          dispatch(updateLoader(false));
          fetchQuestions();
        }
      } catch (error) {
        if (
          error?.response?.status === 405 ||
          error?.response?.status === 406 ||
          error?.response?.status === 401
        ) {
          return sessionExpired(error?.response?.data?.message);
        }
      }
    }
  };

  const removeOption = (index, optionIndex, name) => {
    const newQuestions = [...questions];
    newQuestions[index][name].splice(optionIndex, 1);
    setQuestions(newQuestions);
    ClearOptionValidation();
  };
  const handleQuestion = (event, name, index) => {
    const newQuestions = [...questions];
    newQuestions[index][name] = event.target.value;
    setQuestions(newQuestions);
    setMaxLength(
      event.target.value === Labels.LongText
        ? longTextLenght
        : event.target.value === Labels.ShortText
          ? shortTextLenght
          : maxLength,
    );
    if (
      event.target.value === Labels.ShortText ||
      event.target.value === Labels.LongText ||
      event.target.value === Labels.SingleSelect ||
      event.target.value === Labels.MultiSelect
    ) {
      newQuestions[index].question = "";
    }
  };
  const handleOption = (event, name, index, optionIndex) => {
    const newQuestions = [...questions];
    newQuestions[index][name][optionIndex] = event.target.value;
    setQuestions(newQuestions);
  };

  const questionTypes = [
    {
      label: Labels.LongText,
      value: Labels.LongText,
    },
    {
      label: Labels.ShortText,
      value: Labels.ShortText,
    },
    {
      label: Labels.MultiSelect,
      value: Labels.MultiSelect,
    },
    {
      label: Labels.SingleSelect,
      value: Labels.SingleSelect,
    },
  ];
  const handleSubmit = async (id) => {
    const isValid =
      ValidateQuestions.current.allValid() &&
      ValidateType.current.allValid() &&
      ValidateOption.current.allValid();

    // 🔴 Show errors ONLY when Save is clicked
    if (!isValid) {
      ValidateQuestions.current.showMessages();
      ValidateType.current.showMessages();
      ValidateOption.current.showMessages();
      forceUpdate(true);
      return;
    }
    let selectedIndex =
      id === null ? index : questions.findIndex((q) => q.id === id);
    let allowedTypes = [
      Labels.MultipleChoice,
      Labels.MultiSelect,
      Labels.SingleSelect,
    ];

    const buildSubObj = (list) => {
      const obj = {};
      list.forEach((val, i) => (obj[i + 1] = val));
      return obj;
    };

    // Check for empty options first
    const hasEmptyOptions =
      allowedTypes.includes(questions[selectedIndex].type) &&
      questions[selectedIndex].subQuestion.some(
        (option) => !option || option.trim() === "",
      );

    if (hasEmptyOptions) {
      return dispatch(
        updateSnackbar({
          type: "error",
          message: "Please enter a valid question before saving.",
        }),
      );
    }

    // Check for duplicate options
    const duplicates = checkDuplicateOptions(
      questions[selectedIndex].subQuestion,
    );
    if (duplicates && duplicates.size > 0) {
      return dispatch(
        updateSnackbar({
          type: "error",
          message: "Duplicates not allowed",
        }),
      );
    }

    // Normalize type and options, then filter empty/whitespace-only options
    const qType = (questions[selectedIndex].type || "")
      .toString()
      .trim()
      .toLowerCase();
    const allowedLower = allowedTypes.map((t) =>
      t.toString().trim().toLowerCase(),
    );

    const filteredSubQuestion = (questions[selectedIndex].subQuestion || [])
      .map((opt) =>
        opt === null || opt === undefined ? "" : opt.toString().trim(),
      )
      .filter((opt) => opt !== "");

    const subObj = buildSubObj(filteredSubQuestion);

    const hasMinimumOptions =
      allowedLower.includes(qType) && filteredSubQuestion.length >= 2;

    const validOptions =
      (allowedLower.includes(qType) && hasMinimumOptions) ||
      !allowedLower.includes(qType);

    if (!validOptions) {
      return dispatch(
        updateSnackbar({
          type: "error",
          message: "Please add at least two options",
        }),
      );
    }

    let questionPayload = {
      question: questions[selectedIndex].question,
      type: questions[selectedIndex].type,
      subQuestion: allowedLower.includes(qType) ? subObj : null,
      status: questions[selectedIndex].status,
      jobPostingsId: isEdit
        ? questions[selectedIndex].jobPostingsId
        : isClone === true
          ? parseInt(jobDetailsID)
          : questions[selectedIndex].jobPostingsId
            ? questions[selectedIndex].jobPostingsId
            : JobId,
    };

    dispatch(updateLoader(true));

    try {
      const endpoint = isEdit
        ? `${VENDOR_PORTAL_URL}/${JobId}/questions/${id}`
        : isClone === true
          ? `${VENDOR_PORTAL_URL}/${JobId}/questions`
          : VENDOR_PORTAL_URL;

      const response = isEdit
        ? await putApi(
            endpoint,
            questionPayload,
            process.env.REACT_APP_JOBOPENING,
          )
        : await postApi(
            endpoint,
            questionPayload,
            process.env.REACT_APP_JOBOPENING,
          );

      if (
        response.status === 405 ||
        response.status === 406 ||
        response?.status === 401
      ) {
        return sessionExpired(
          response?.message || "Session expired. Please login again.",
        );
      }

      if (response.status !== 200) {
        const msg = response?.message || `API Error (${response.status})`;
        throw new Error(msg);
      }

      // ✅ API SUCCESS – update questions / UI first
      if (!isEdit) {
        const updated = [...questions];
        updated[selectedIndex] = {
          ...updated[selectedIndex],
          id: response?.data?.id || questions.length + 1,
        };
        setQuestions(updated);
      }

      setIsEdit(null);

      // ⬇️ IMPORTANT: wait for fetchQuestions to finish and only then show snackbar
      if (fetchQuestions) {
        await fetchQuestions(); // safe even if fetchQuestions is not async
      }

      // 🔔 NOW show success message – this is the LAST updateSnackbar call
      dispatch(
        updateSnackbar({
          type: "success",
          message: isEdit
            ? "Question updated successfully"
            : "Screening Question added successfully",
        }),
      );
    } catch (err) {
      if (
        err?.response?.status === 405 ||
        err?.response?.status === 406 ||
        err?.response?.status === 401
      ) {
        return sessionExpired(err?.response?.data?.message);
      }
      console.error("Question submit error:", err);
      dispatch(
        updateSnackbar({
          type: "error",
          message: "Something went wrong. Please try again.",
        }),
      );
    } finally {
      dispatch(updateLoader(false));
    }
  };

  const ClearOptionValidation = () => {
    setQuestions((prev) => {
      const copy = [...prev];
      return copy;
    });
    ValidateOption.current.hideMessages();
    ValidateQuestions.current.hideMessages();
    ValidateType.current.hideMessages();
    forceUpdate((v) => v + 1);
  };

  const checkDuplicateOptions = (options) => {
    if (!options || options.length === 0) return null;

    const trimmedOptions = options.map((opt) =>
      opt === null || opt === undefined
        ? ""
        : opt.toString().trim().toLowerCase(),
    );

    const duplicates = new Set();
    const seen = new Set();

    trimmedOptions.forEach((opt, index) => {
      if (opt !== "") {
        if (seen.has(opt)) {
          duplicates.add(opt);
        }
        seen.add(opt);
      }
    });

    return duplicates.size > 0 ? duplicates : null;
  };

  const handleEdit = (index) => {
    setIsEdit(index);
    let obj = JSON.parse(JSON.stringify(questions));
    let findindex = obj.findIndex((x) => x.id === item.id);
    if (findindex !== -1) {
      obj[findindex].isEdit = true;
    }
    setQuestions(obj);
    setMaxLength(item.type === "Long Text" ? longTextLenght : shortTextLenght);
  };

  useEffect(() => {
    console.log("isEdit", isEdit);
  }, [isEdit]);

  const handleDelete = (index) => {
    setDeleteIndex(index);
    setOpenPopup(true);
  };
  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";

  return (
    <div className="p-1 text-left jobPortal">
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          {/* card action start here */}

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "baseline",
              marginBottom: "13px",
            }}
          >
            {isEdit === item.id && item.isEdit === true ? (
              <>
                <Button
                  className="buttonHover"
                  variant="default"
                  onClick={() => {
                    setIsEdit(null);
                    ClearOptionValidation();
                    fetchQuestions();
                  }}
                  size="small"
                  style={{ width: "6rem" }}
                >
                  <Link
                    href="#"
                    className="cancel-btn"
                    style={{ color: "red" }}
                    underline="always"
                  >
                    Cancel
                  </Link>
                </Button>
                <Button
                  className="buttonHover"
                  size="small"
                  variant="contained"
                  style={{
                    backgroundColor: "var(--primary-bg-color)",
                    color: "var(--primary-background-text-color)",
                    borderRadius: "10px",
                    width: "6rem",
                    fontSize: "14px",
                    fontWeight: "",
                    marginleft: "20px",
                  }}
                  onClick={() => handleSubmit(item.id)}
                >
                  Save
                </Button>
              </>
            ) : isEdit === null &&
              questions.every((e) => {
                return e.isEdit === false;
              }) ? (
              <>
                <div
                  onClick={() => handleEdit(item.id)}
                  style={{
                    display: "inline-block",
                    cursor: "pointer",
                    marginRight: "15px",
                  }}
                >
                  <EditingIcon />
                </div>
                <img
                  src={DeleteIcon}
                  alt="delete icon"
                  style={{ marginleft: 0 }}
                  onClick={() => handleDelete(index)}
                />
              </>
            ) : null}
          </div>

          <div style={{ marginBottom: "10px" }}>
            {isEdit === item.id ? (
              <TextField
                sx={{
                  width: "100%",
                  //  '& fieldset': { border: 'none' }
                }}
                fullWidth
                multiline
                variant="outlined"
                value={item.question}
                onChange={(e) => handleQuestion(e, "question", index)}
              />
            ) : (
              <p style={{ fontSize: "18px", lineHeight: "1.6", margin: 0 }}>
                <strong>Q{index + 1}.</strong> {item.question}{" "}
                <Chip
                  label={item.type}
                  size="small"
                  sx={{
                    verticalAlign: "middle",
                    color: "#000",
                    fontWeight: "500",
                  }}
                />
              </p>
            )}
          </div>

          {/* pop-up action here */}
          <Dialog
            open={openPopup}
            keepMounted
            onClose={() => setOpenPopup(false)}
            aria-describedby="alert-dialog"
            style={{ marginTop: "-26%" }}
          >
            <Box sx={{ width: "395px" }}>
              <DialogTitle className="diabtn">Confirm</DialogTitle>
              <DialogContent>
                <DialogContentText className="diabtnjob" id="alert-dialog">
                  <p className="btntext">Are you sure you want to delete ?</p>
                </DialogContentText>
              </DialogContent>
              <DialogActions className="alert-actionbtns">
                <Button onClick={() => setOpenPopup(false)}>
                  <Link href="#" color="#000" underline="always">
                    Cancel
                  </Link>
                </Button>
                <Button
                  onClick={() => {
                    removeQuestion(deleteIndex);
                    setOpenPopup(false);
                  }}
                >
                  Delete
                </Button>
              </DialogActions>
            </Box>
          </Dialog>

          {/* card action end here */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{ display: "block", textAlign: "right", width: "100%" }}
            >
              {isEdit === item.id && item.isEdit === true ? (
                <>
                  {(item.type === Labels.LongText ||
                    item.type === Labels.ShortText) && (
                    <p
                      style={{
                        color:
                          item?.question?.length > maxLength ? "red" : "green",
                      }}
                    >
                      {item?.question?.length}/{maxLength}
                    </p>
                  )}
                </>
              ) : (
                ""
              )}
            </div>
          </div>

          {/* add option here  */}

          {ValidateQuestions.current.message(
            `Question`,
            item.question,
            `required|min:1|max:${item.type === Labels.ShortText ? shortTextLenght : longTextLenght}`,
          )}
          {/* for Options section start here*/}
          {item.type === Labels.SingleSelect &&
            item.type !== Labels.MultiSelect && (
              <Grid
                container
                spacing={0}
                style={{
                  marginTop: "7px",
                  width: "100%",
                  border: "1px solid #efefef",
                  padding: "5px 15px 5px 0px",
                  borderRadius: "4px",
                  backgroundColor: "#f5f5f5cf",
                }}
              >
                {item.subQuestion.map((option, optionIndex) => (
                  <Grid item xs={12} sm={6} md={3} key={optionIndex}>
                    <div className="d-flex" style={{ alignItems: "center" }}>
                      <TextField
                        size="small"
                        sx={{
                          width: "220px",
                          padding: "0px",
                          "& fieldset": { border: "none" },
                        }}
                        variant="outlined"
                        className=""
                        value={option}
                        disabled={
                          !isClone && item.id !== null && isEdit !== item.id
                        }
                        onChange={(event) =>
                          handleOption(event, "subQuestion", index, optionIndex)
                        }
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <PanoramaFishEyeIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                      {item.subQuestion.length > 1 &&
                        (item.id === null || isEdit === item.id) && (
                          <CloseIcon
                            onClick={() =>
                              removeOption(index, optionIndex, "subQuestion")
                            }
                            style={{ color: "#999999ff", cursor: "pointer" }}
                          />
                        )}
                    </div>
                    {ValidateOption.current.message(
                      "This Option",
                      option,
                      "required",
                    )}
                  </Grid>
                ))}
              </Grid>
            )}
          {/* for Options section end here*/}

          {/* for multiselect option section start here */}
          {item.type !== Labels.SingleSelect &&
            item.type === Labels.MultiSelect && (
              <Grid
                container
                spacing={0}
                style={{
                  marginTop: "7px",
                  width: "100%",
                  border: "1px solid #efefef",
                  borderRadius: "4px",
                  padding: "5px 15px 5px 0px",
                  backgroundColor: "#f5f5f5cf",
                }}
              >
                {item.subQuestion.map((option, optionIndex) => (
                  <Grid item xs={12} sm={6} md={3} key={optionIndex}>
                    <div className="d-flex" style={{ alignItems: "center" }}>
                      <TextField
                        sx={{
                          width: "220px",
                          padding: "0px",
                          "& fieldset": { border: "none" },
                        }}
                        size="small"
                        variant="outlined"
                        className=""
                        value={option}
                        disabled={
                          !isClone && item.id !== null && isEdit !== item.id
                        }
                        onChange={(event) =>
                          handleOption(event, "subQuestion", index, optionIndex)
                        }
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <CheckBoxOutlineBlankIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                      {item.subQuestion.length > 1 &&
                        (item.id === null || isEdit === item.id) && (
                          <CloseIcon
                            onClick={() =>
                              removeOption(index, optionIndex, "subQuestion")
                            }
                            style={{
                              color: "#999999ff",
                              fontSize: "20px",
                              cursor: "pointer",
                            }}
                          />
                        )}
                    </div>
                    {ValidateOption.current.message(
                      "This Option",
                      option,
                      "required",
                    )}
                  </Grid>
                ))}
              </Grid>
            )}
          <div>
            {isEdit === item.id &&
              (item.type === Labels.MultiSelect ||
                (item.type === Labels.SingleSelect &&
                  item.subQuestion.length < 4)) && (
                <div
                  onClick={() => {
                    const hasEmptyOption = item.subQuestion.some(
                      (opt) => !opt || opt.trim() === "",
                    );
                    if (!hasEmptyOption) {
                      addOption(index, item.type);
                    }
                  }}
                  className={
                    (ValidateQuestions.current.allValid() ||
                      ValidateType.current.allValid() ||
                      ValidateOption.current.allValid()) &&
                    !item.subQuestion.some((opt) => !opt || opt.trim() === "")
                      ? "cursor-pointer addoption"
                      : "cursor-pointer addoption disabled"
                  }
                >
                  <IconButton className="addiconbutton">
                    {/* <img src={process.env.PUBLIC_URL + "/assests/img/Group 2196.png"} alt="" className='circleplusicon' /> */}
                    <DashboardPlusicon width={35} height={36} />
                  </IconButton>
                  <span>Add New Option</span>
                </div>
              )}
          </div>
          {/* for multiselect option section end here */}
        </Grid>

        {/* </Grid> */}
        {/* <Grid item xs={12} sm={2}>
          <h4>Type</h4>
          <FormControl fullWidth>
            <Select
              labelId="demo-simple-select-autowidth-label"
              id="demo-simple-select-autowidth"
              value={item.type} size='small'
              disabled
              onChange={(event) => handleQuestion(event, 'type', index)}
            >
              {questionTypes.map((item) => (
                <MenuItem value={item.value}>{item.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <div className='mt-2'>
            {validator.current.message(`Type `, item.type, "required")}
          </div>
        </Grid> */}

        <div style={{ width: "20px" }}></div>
        <div
          className="addQuestionBtnsContext cursor-pointer"
          style={{
            marginLeft: "auto",
            alignItems: isClone === true ? "" : "baseline",
          }}
        >
          <div style={{ width: "20px" }}></div>
          {isClone === true ? (
            <>
              <img
                src={DeleteIcon}
                alt="delete icon"
                className="vendor-icon delete-icon"
                style={{ paddingTop: "10px" }}
                onClick={() => handleDelete(index)}
              />
              <Button
                className="buttonHover"
                size="small"
                disabled={
                  compare?.some((item) => item.isEdit === true) ?? false
                }
                variant="contained"
                style={{
                  backgroundColor: "var(--primary-bg-color)",
                  color: "var(--primary-background-text-color)",
                  borderRadius: "10px",
                  width: "6rem",
                  fontSize: "14px",
                  fontWeight: "",
                  marginleft: "20px",
                }}
                onClick={() => handleSubmit(item.id)}
              >
                Save
              </Button>
            </>
          ) : (
            ""
          )}
        </div>
      </Grid>
    </div>
  );
};
const ComponentRenderData = ({
  onReceivechildProps,
  jobDetailsID,
  questionsData: questions,
  setQuestions,
  getCreatedJob,
}) => {
  const dispatch = useDispatch();
  const ValidateQuestions2 = ValidatesQuestions();
  const ValidateType2 = ValidatesType();
  const ValidateOption2 = ValidatesOption();
  const [, forceUpdate] = useState(false);
  const [isEdit, setIsEdit] = React.useState(null);
  const [questionsArray, setQuestionsArray] = useState(questions);
  const [jobCode, setJobCode] = useState(null);
  const JobId = jobDetailsID;
  const [maxLength, setMaxLength] = useState(shortTextLenght);
  const inputRefs = useRef({});

  // const token = getAccessToken();

  useEffect(() => {
    if (JobId) {
      let subPathObj = JSON.parse(localStorage.getItem("subpathObj"));
      if (subPathObj && subPathObj.length > 0) {
        let index = subPathObj.findIndex((x) => x.id === JobId);
        let jobCode = "";
        if (index !== -1) {
          jobCode = subPathObj[index].name;
        } else {
          if (getCreatedJob) {
            let isJobCode = getCreatedJob.jobCode;
            setJobCode(isJobCode);
          }
        }

        if (jobCode) {
          let matches = jobCode.match(/\(([^)]+)\)/g);
          let splitJobcode = matches[matches.length - 1].replace(/[()]/g, "");
          setJobCode(splitJobcode);
        }
      } else {
        if (getCreatedJob) {
          let isJobCode = getCreatedJob.jobCode;
          setJobCode(isJobCode);
        }
      }
    }
  }, [JobId, getCreatedJob]);

  const addOption = (index) => {
    const newQuestions = [...questionsArray];
    const newOptionIndex = newQuestions[index]["subQuestion"].length;
    newQuestions[index]["subQuestion"].push("");
    setQuestionsArray(newQuestions);
    // Focus newly added option input
    setTimeout(() => {
      const input = inputRefs.current[`${index}-${newOptionIndex}`];
      if (input) {
        input.focus(); // this scrolls into view
      }
    }, 0);
  };

  const removeOption = (index, optionIndex, name) => {
    const newQuestions = [...questionsArray];
    newQuestions[index][name].splice(optionIndex, 1);
    setQuestionsArray(newQuestions);
    {
      ValidateOption2.current.message(
        `Option ${optionIndex + 1} `,
        newQuestions[index][name][0],
        "",
      );
    }
  };
  const handleQuestion = (event, name, index) => {
    const newQuestions = [...questionsArray];
    newQuestions[index][name] = event.target.value;
    newQuestions[index].subQuestion = [""];
    if (name === "type" || name === "question") {
      ValidateQuestions2.current.hideMessages();
      ValidateOption2.current.hideMessages();
    }

    {
      ValidateOption2.current.message(
        `Option ${index + 1} `,
        newQuestions[index].subQuestion[0],
        "",
      );
    }
    setQuestionsArray(newQuestions);
    setMaxLength(
      event.target.value === Labels.LongText
        ? longTextLenght
        : event.target.value === Labels.ShortText
          ? shortTextLenght
          : maxLength,
    );
    // if (
    //   event.target.value === Labels.ShortText ||
    //   event.target.value === Labels.LongText ||
    //   event.target.value === Labels.SingleSelect ||
    //   event.target.value === Labels.MultiSelect
    // ) {
    //   newQuestions[index].question = '';
    // }
  };

  const handleOption = (event, name, index, optionIndex) => {
    const newQuestions = [...questionsArray];
    newQuestions[index][name][optionIndex] = event.target.value;
    setQuestionsArray(newQuestions);
  };

  const checkDuplicateOptions = (options) => {
    if (!options || options.length === 0) return null;

    const trimmedOptions = options.map((opt) =>
      opt === null || opt === undefined
        ? ""
        : opt.toString().trim().toLowerCase(),
    );

    const duplicates = new Set();
    const seen = new Set();

    trimmedOptions.forEach((opt, index) => {
      if (opt !== "") {
        if (seen.has(opt)) {
          duplicates.add(opt);
        }
        seen.add(opt);
      }
    });

    return duplicates.size > 0 ? duplicates : null;
  };

  const questionTypes = [
    {
      label: Labels.LongText,
      value: Labels.LongText,
    },
    {
      label: Labels.ShortText,
      value: Labels.ShortText,
    },
    {
      label: Labels.MultiSelect,
      value: Labels.MultiSelect,
    },
    {
      label: Labels.SingleSelect,
      value: Labels.SingleSelect,
    },
  ];

  const handleSubmit = async (id) => {
    dispatch(updateSnackbar({ type: "", message: "" }));
    const getUserId = await GetUserId();
    let selectedIndex =
      id === null ? 0 : questionsArray.findIndex((q) => q.id === id);

    // Validation for MultiSelect and SingleSelect
    const optionTypes = [Labels.MultiSelect, Labels.SingleSelect];
    const currentType = questionsArray[selectedIndex].type;
    const hasOptionType = optionTypes.includes(currentType);

    // Check for empty options if it's a MultiSelect or SingleSelect
    if (hasOptionType) {
      const rawOptions = questionsArray[selectedIndex].subQuestion || [];
      const trimmedOptions = rawOptions.map((o) =>
        o === null || o === undefined ? "" : o.toString().trim(),
      );

      const hasEmptyOptions = trimmedOptions.some((opt) => !opt);
      if (hasEmptyOptions) {
        return dispatch(
          updateSnackbar({
            type: "error",
            message: "Please enter a valid question before saving.",
          }),
        );
      }

      // Check for duplicate options
      const duplicates = checkDuplicateOptions(
        questionsArray[selectedIndex].subQuestion,
      );
      if (duplicates && duplicates.size > 0) {
        return dispatch(
          updateSnackbar({
            type: "error",
            message: "Duplicates not allowed",
          }),
        );
      }

      const filteredOptions = trimmedOptions.filter((opt) => opt !== "");
      if (filteredOptions.length < 2) {
        return dispatch(
          updateSnackbar({
            type: "error",
            message: "Please add at least two options",
          }),
        );
      }
    }

    if (
      ValidateQuestions2.current.allValid() &&
      ValidateType2.current.allValid() &&
      ValidateOption2.current.allValid()
    ) {
      // Build options object for MultiSelect and SingleSelect
      const buildSubObj = (list) => {
        const obj = {};
        list.forEach((val, i) => (obj[i + 1] = val));
        return obj;
      };

      let subQuestion = null;
      if (hasOptionType) {
        const rawOptions = questionsArray[selectedIndex].subQuestion || [];
        const trimmedOptions = rawOptions.map((o) =>
          o === null || o === undefined ? "" : o.toString().trim(),
        );
        const filteredOptions = trimmedOptions.filter((opt) => opt !== "");
        subQuestion = buildSubObj(filteredOptions);
      }

      const question = {
        question: questionsArray[selectedIndex].question,
        type: questionsArray[selectedIndex].type,
        subQuestion: subQuestion,
        status: questionsArray[selectedIndex].status,
      };

      const finalObj = {
        jobPostingsId: questionsArray[selectedIndex].jobPostingsId,
        questions: [question],
      };

      let getUserDetails = await getAttributes();
      const headers = {
        "Content-Type": "application/json",
        Customerid: getUserId,
        jobCode,
        userId: getUserDetails?.[0]?.userId,
        // Authorization: token ? `Bearer ${token}` : '',
      };

      const url = isEdit
        ? `${process.env.REACT_APP_JOBOPENING}${VENDOR_PORTAL_URL}/${id}`
        : `${process.env.REACT_APP_JOBOPENING}${VENDOR_PORTAL_URL}/${JobId}/questions`;

      const method = isEdit ? "PUT" : "POST";

      dispatch(updateLoader(true));

      try {
        const res = await axios({
          url: url,
          method: method,
          data: finalObj,
          headers: headers,
          withCredentials: true, // axios version
        });

        // 🔹 session expired case (same as your working code)
        if (res.status === 405 || res.status === 406 || res?.status === 401) {
          return sessionExpired(
            res?.message || "Session expired. Please login again.",
          );
        }

        // // 🔹 other API error codes
        // if (!res.ok) {
        //   const msg = res?.message || `API Error ${res.status}`;
        //   throw new Error(msg);
        // }

        // ✅ SUCCESS: update local state first
        if (!isEdit) {
          let updated = [...questionsArray];
          updated[selectedIndex].id =
            res?.data?.id || questionsArray.length + 1;
          setQuestions(updated);
        }
        const showSnackbar = {
          type: "success",
          message: isEdit
            ? "Question Updated Successfully"
            : "Screening question added successfully",
        };
        setIsEdit(null);
        onReceivechildProps(false, showSnackbar);

        // 🔔 Show success snackbar LAST so nothing overwrites it
      } catch (error) {
        console.error("Error saving question:", error);
        if (
          error?.response?.status === 405 ||
          error?.response?.status === 406 ||
          error?.response?.status === 401
        ) {
          return sessionExpired(error?.response?.data?.message);
        }
        dispatch(
          updateSnackbar({
            type: "error",
            message: "Something went wrong. Please try again.",
          }),
        );
      } finally {
        dispatch(updateLoader(false));
      }
    } else {
      if (questionsArray[selectedIndex].question === "") {
        dispatch(
          updateSnackbar({
            type: "error",
            message: "Question is required",
          }),
        );
      }

      ValidateQuestions2.current.showMessages();
      ValidateType2.current.showMessages();
      ValidateOption2.current.showMessages();
      forceUpdate(true);
    }
  };

  const handleEdit = (index) => {
    setIsEdit(index);
  };
  const handleDelete = (index) => {
    onReceivechildProps(false, true);
  };
  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";

  return (
    <div style={{ marginTop: "-28px" }}>
      {questions &&
        questions.length > 0 &&
        questions.slice(0, 1).map((item, index) => (
          <>
            <div
              style={{
                border: "2px solid #e8eaec",
                borderRadius: "10px",
                backgroundColor: "#f9fafc",
                height: "100%",
                padding: "10px",
              }}
            >
              <div
                className="p-1 text-left"
                // style={{ marginTop: '-20px', maxHeight: '40px' }}
              >
                <div className="">
                  <p className="question1">{Labels.Question} </p>
                </div>
                <div className=" ">
                  <div>
                    <TextField
                      sx={{
                        "& fieldset": { border: "none" },
                      }}
                      error={item?.question?.length > maxLength ? true : false}
                      multiline={true}
                      className="input-option"
                      variant="outlined"
                      color="success"
                      autoComplete="off"
                      rows={
                        item.type === Labels.LongText
                          ? "5"
                          : item.type === Labels.ShortText
                            ? "2"
                            : ""
                      }
                      // label={`Enter your screening Question...`}
                      placeholder="Enter your Screening Question..."
                      value={item.question}
                      disabled={item.id !== null && isEdit !== item.id}
                      onChange={(event) =>
                        handleQuestion(event, "question", index)
                      }
                    />

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "96%",
                      }}
                    >
                      <span>
                        {" "}
                        {ValidateQuestions2.current.message(
                          `Question`,
                          item.question,
                          `required|min:1|max:${item.type === Labels.ShortText ? shortTextLenght : longTextLenght}`,
                        )}
                      </span>
                      {(item.type === Labels.LongText ||
                        item.type === Labels.ShortText) && (
                        <span
                          style={{
                            marginTop: "7px",
                            color:
                              item?.question?.length > maxLength
                                ? "red"
                                : "green",
                          }}
                        >
                          {item?.question?.length}/{maxLength}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="">
                  <p className="question1" style={{ marginTop: "20px" }}>
                    {"Question Type"}{" "}
                  </p>
                </div>
                <div className="questionType">
                  <FormControl
                    fullWidth
                    sx={{
                      "& fieldset": { border: "none" },
                    }}
                    size="small"
                    className="smalltextfeild"
                  >
                    <Select
                      className="smalltextfeild"
                      label="Select Type"
                      labelId="demo-simple-select-autowidth-label"
                      id="demo-simple-select-autowidth"
                      autoComplete="off"
                      placeholder="selected value"
                      value={item.type}
                      disabled={item.id !== null && isEdit !== item.id}
                      onChange={(event) => handleQuestion(event, "type", index)}
                    >
                      {questionTypes.map((item) => (
                        <MenuItem value={item.value}>{item.label}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <div className="validationright">
                    {ValidateType2.current.message(
                      `Type `,
                      item.type,
                      "required",
                    )}
                  </div>
                </div>
                {/* options */}
                {(item.id === null || isEdit === item.id) &&
                  (item.type === Labels.SingleSelect ||
                    item.type === Labels.MultiSelect) && (
                    <div className="autoScroll">
                      {item.subQuestion.map((option, optionIndex) => (
                        <div
                          className="mb-2 d-flex"
                          style={{ alignItems: "center", width: "40%" }}
                        >
                          <div>
                            <TextField
                              sx={{
                                width:
                                  item.subQuestion.length > 4
                                    ? "30rem"
                                    : "30rem",
                              }}
                              variant="outlined"
                              className="input-option"
                              autoComplete="off"
                              label={`Option `}
                              value={option}
                              disabled={item.id !== null && isEdit !== item.id}
                              onChange={(event) =>
                                handleOption(
                                  event,
                                  "subQuestion",
                                  index,
                                  optionIndex,
                                )
                              }
                              inputRef={(el) => {
                                inputRefs.current[`${index}-${optionIndex}`] =
                                  el;
                              }}
                            />
                            {/* {ValidateOption2.current.message(`Option ${optionIndex + 1} `, option, "required|min:1|max:80")} */}
                          </div>
                          {item.subQuestion.length > 1 && (
                            <CloseIcon
                              style={{ color: "#999999ff", cursor: "pointer" }}
                              onClick={() =>
                                removeOption(index, optionIndex, "subQuestion")
                              }
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  )}

                {(item.type === Labels.MultiSelect ||
                  (item.type === Labels.SingleSelect &&
                    item.subQuestion.length < 4)) && (
                  <div
                    className="d-flex  align-items-center"
                    style={{ justifyContent: "end" }}
                  >
                    <div
                      onClick={(e) => addOption(index)}
                      className="cursor-pointer addoption"
                    >
                      <IconButton className="addiconbutton">
                        <DashboardPlusicon width={35} height={36} />
                      </IconButton>
                      <span>Add New Option</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="d-flex justify-content-end align-items-center question-bts topBtn">
              <div className="items-alignment cursor-pointer">
                <Button
                  variant="text"
                  className="buttonHover"
                  style={{ color: "red", fontWeight: "bolder", width: "96px" }}
                  size="small"
                  onClick={() => handleDelete(index)}
                >
                  <Link href="#" className="cancel-btn" underline="always">
                    Cancel
                  </Link>
                </Button>
                {item.id === null || isEdit === item.id ? (
                  <Button
                    className="buttonHover1"
                    size="small"
                    variant="contained"
                    disabled={item?.question?.length > maxLength}
                    style={{
                      backgroundColor: "var(--primary-bg-color)",
                      fontSize: "14px",
                      width: "96px",
                      color: "var(--primary-background-text-color)",
                      borderRadius: "10px",
                    }}
                    onClick={() => handleSubmit(item.id)}
                  >
                    Save
                  </Button>
                ) : (
                  <div
                    onClick={() => handleEdit(item.id)}
                    style={{ display: "inline-block", cursor: "pointer" }}
                  >
                    <EditingIcon />
                  </div>
                )}
              </div>
            </div>
          </>
        ))}
    </div>
  );
};
export default ScreeningQuestions;
